import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Timer } from "lucide-react";

export const SoglieDialog = ({ open, onClose, onSaved }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { if (open) api.get("/sinistri/config/soglie").then(({ data }) => setCfg(data)); }, [open]);
  const save = async () => {
    try {
      await api.put("/sinistri/config/soglie", { soglie: cfg.soglie });
      toast.success("Soglie aggiornate"); onSaved?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sin-soglie-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><Timer className="h-5 w-5 text-red-600" /> Soglie promemoria</DialogTitle>
          <DialogDescription>Dopo quanti giorni nello stesso stato il sinistro viene segnalato come fermo.</DialogDescription>
        </DialogHeader>
        {cfg && (
          <div className="space-y-2 py-1">
            {Object.keys(cfg.soglie).map((k) => (
              <div key={k} className="flex items-center justify-between gap-3">
                <span className="text-sm text-slate-700">{cfg.etichette[k]}</span>
                <div className="flex items-center gap-1.5">
                  <Input type="number" min={1} max={730} className="w-20 h-9 text-right" value={cfg.soglie[k]}
                    onChange={(e) => setCfg((c) => ({ ...c, soglie: { ...c.soglie, [k]: e.target.value } }))} data-testid={`sin-soglia-${k}`} />
                  <span className="text-xs text-slate-400">giorni</span>
                </div>
              </div>
            ))}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={!cfg} className="bg-red-600 hover:bg-red-700 text-white" data-testid="sin-soglie-save">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
